export default __webpack_public_path__ + "static/media/ieatyourheart.17c1df5e.png";